import { render, staticRenderFns } from "./WorkerRegistrationStepLayout.vue?vue&type=template&id=bc3d60fa"
import script from "./WorkerRegistrationStepLayout.vue?vue&type=script&lang=js"
export * from "./WorkerRegistrationStepLayout.vue?vue&type=script&lang=js"
import style0 from "./WorkerRegistrationStepLayout.vue?vue&type=style&index=0&id=bc3d60fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports